export class EventService {

  static async fetchEvent(id) {
    const apiUrl = `https://azure-fn-mescadeauxgratuits.azurewebsites.net/api/get-campaign-info?campId=${id}`; 

    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        console.error(`Error fetching event ${id}: ${response.statusText}`);
        return null; 
      }

      const data = await response.json();

      const event = {
        dates: data.dates|| [],
        generalImage: data.generalImage || "",
        locationName: data.locationName || "",
        locationZip: data.locationZip || "",
        locationStreet: data.locationStreet || "",
        locationCityName: data.locationCityName || "",
        locationDetails: data.locationDetails || "",
        gifts: data.gifts?.map(gift => ({
          title: gift.title || "",
          description: gift.description,
          imageUrl: gift.imageUrl || "",
        })) || [],
        rouletteImage: data.rouletteImage || "",
      };

      return event;

    } catch (error) {
      console.error(`Failed to fetch or parse event ${id}:`, error);
      return null;
    }
  }
}
